import { render, staticRenderFns } from "./dashboard-activities-card.vue?vue&type=template&id=e63f3750&scoped=true&"
import script from "./dashboard-activities-card.vue?vue&type=script&lang=ts&"
export * from "./dashboard-activities-card.vue?vue&type=script&lang=ts&"
import style0 from "./dashboard-activities-card.vue?vue&type=style&index=0&id=e63f3750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63f3750",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardTitle})
